import { useState } from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const [done, setDone] = useState(false);
  return (
    <span
      className={`-mb-[0.3em] -ml-[0.06em] block pb-[0.3em] pl-[0.06em] ${
        done ? "" : "overflow-hidden"
      } ${className}`}
    >
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.1, delay, ease: EASE }}
        onAnimationComplete={() => setDone(true)}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);
